var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button-group',{attrs:{"vertical":""}},[_c('b-button',{attrs:{"size":"sm","variant":"outline-info"},on:{"click":_vm.requestEditForm}},[_c('b-icon-pen-fill')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }